module.exports = __webpack_public_path__ + "img/menucn-5-6.c315a204.svg";